<template>
  <div class="shop_foot width_center_1200">
    <shop-index-adv :adv="adv"></shop-index-adv>
    <!-- <ul>
            <li><router-link to="">品质保证</router-link></li>
            <li><router-link to="">7天退货 15天换货</router-link></li>
            <li><router-link to=""></router-link></li>
        </ul> -->
    <div class="foot_copyright">
      <p>{{footCopyrightInfo}}</p>
      <p><a href="https://beian.miit.gov.cn/">{{footRecordInformation}}</a></p>
    </div>
  </div>
</template>

<script>
import ShopIndexAdv from "@/components/home/public/shop_index_adv.vue";

import defaultSettings from "@/config/defaultSettings";
import { config as defaultConfig } from '@/api/config/default.js'
export default {
  components: {
    ShopIndexAdv,
  },
  props: {},
  data() {
    return {
      adv: {},
      info: {},
            footCopyrightInfo:defaultConfig.footCopyrightInfo,
            footRecordInformation:defaultConfig.footRecordInformation
    };
  },
  watch: {},
  computed: {},
  methods: {
    get_foot_info: function () {
      // this.$get(this.$api.homeGetFootInfo).then(res=>{
      //     this.adv = res.data.adv.adv[0];
      //     this.info = res.data.info;
      // });
    },
  },
  created() {
    this.get_foot_info();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.shop_foot {
  padding-top: 10px;
  text-align: center;
  ul {
    margin: 40px auto 0 auto;
    width: 664px;
    border-top: 1px solid #efefef;
    padding-top: 40px;
  }
  ul li {
    float: left;
    margin-right: 40px;
    margin-bottom: 60px;
    font-size: 14px;
    a:hover {
      color: #ca151e;
    }
  }
  ul li:last-child {
    margin-right: 0px;
  }
  .foot_copyright {
    clear: both;
    font-size: 12px;
    line-height: 35px;
    padding-bottom: 20px;
  }
}
</style>